export default __webpack_public_path__ + "static/media/april-2018-school-day.f9544b2a.csv";